// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"7042412f","177":"62af7a28","288":"b92aea30","480":"676699e0","972":"afde9f05"}[chunkId] + ".chunk.js";
};